var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2049,
    height: 1152,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 1908.8,
    x2: 1956.7,
    y1: 789,
    y2: 788.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 1908.8,
    x2: 1956.2,
    y1: 793.9,
    y2: 793.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 1908.8,
    x2: 1956.7,
    y1: 789,
    y2: 788.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58403a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a78f89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 1225.6,
    x2: 1423.6,
    y1: 760.4,
    y2: 755.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe946b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 1225.6,
    x2: 1423.6,
    y1: 760.4,
    y2: 755.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 1372.2,
    x2: 1430.7,
    y1: 761.6,
    y2: 760.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe946b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 1335.6,
    x2: 1477.7,
    y1: 761.2,
    y2: 757.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3ab85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#824f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 1423.5,
    x2: 1449.2,
    y1: 761.4,
    y2: 760.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 1423.5,
    x2: 1449.2,
    y1: 761.4,
    y2: 760.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 1550.3,
    x2: 1609.2,
    y1: 762.7,
    y2: 761.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3ab85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#824f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 1550.3,
    x2: 1609.1,
    y1: 762.7,
    y2: 761.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 1490.4,
    x2: 1638,
    y1: 762.2,
    y2: 758.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3ab85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#824f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 1650.3,
    x2: 1755.6,
    y1: 763.3,
    y2: 760.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 1684.7,
    x2: 1802.9,
    y1: 763.4,
    y2: 760.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3ab85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#824f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 1684.7,
    x2: 1803.5,
    y1: 763.4,
    y2: 760.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 1604.3,
    x2: 1675.2,
    y1: 763,
    y2: 761.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ffefdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bba289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: 2114.5,
    x2: 2117.6,
    y1: 743.4,
    y2: 864.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe946b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x1: 122.9,
    x2: 75.1,
    y1: 754,
    y2: 753.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 122.9,
    x2: 75.6,
    y1: 758.9,
    y2: 758.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 122.9,
    x2: 75.1,
    y1: 754,
    y2: 753.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58403a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a78f89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g32",
    x1: 816.3,
    x2: 691,
    y1: 853.5,
    y2: 850.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3ab85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#824f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g33",
    x1: 806.2,
    x2: 608.1,
    y1: 725.4,
    y2: 720.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe946b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x1: 806.2,
    x2: 608.1,
    y1: 725.4,
    y2: 720.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x1: 659.5,
    x2: 601.1,
    y1: 726.6,
    y2: 725.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe946b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g37",
    x1: 696.1,
    x2: 554.1,
    y1: 726.2,
    y2: 722.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3ab85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#824f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g38",
    x1: 608.3,
    x2: 582.6,
    y1: 726.4,
    y2: 725.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g39",
    x1: 608.3,
    x2: 582.6,
    y1: 726.4,
    y2: 725.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g41",
    x1: 481.5,
    x2: 422.6,
    y1: 727.7,
    y2: 726.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3ab85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#824f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g42",
    x1: 481.5,
    x2: 422.6,
    y1: 727.7,
    y2: 726.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g43",
    x1: 541.4,
    x2: 393.7,
    y1: 727.2,
    y2: 723.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3ab85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#824f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g45",
    x1: 381.5,
    x2: 276.2,
    y1: 728.3,
    y2: 725.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g46",
    x1: 347,
    x2: 228.8,
    y1: 728.4,
    y2: 725.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3ab85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#824f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g47",
    x1: 347,
    x2: 228.2,
    y1: 728.5,
    y2: 725.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g49",
    x1: -82.8,
    x2: -85.9,
    y1: 708.5,
    y2: 829.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe946b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g1",
    cx: 1923.9,
    cy: 786.1,
    r: 29.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g5",
    cx: 1946.9,
    cy: 842.9,
    r: 359.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g6",
    cx: 1182.9,
    cy: 932.1,
    r: 118.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g9",
    cx: 1366.2,
    cy: 1001.6,
    r: 68.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g14",
    cx: 1348.8,
    cy: 949,
    r: 198.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g18",
    cx: 1681.5,
    cy: 838.2,
    r: 178.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g23",
    cx: 1589.9,
    cy: 972.3,
    r: 181.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g25",
    cx: 2064.2,
    cy: 864.7,
    r: 101.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g26",
    cx: 107.8,
    cy: 751.1,
    r: 29.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g30",
    cx: 84.8,
    cy: 808,
    r: 359.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g31",
    cx: 848.8,
    cy: 897.1,
    r: 118.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g35",
    cx: 665.5,
    cy: 966.6,
    r: 68.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g40",
    cx: 682.9,
    cy: 914.1,
    r: 198.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g44",
    cx: 350.3,
    cy: 803.2,
    r: 178.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g48",
    cx: 441.8,
    cy: 937.3,
    r: 181.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a78f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g50",
    cx: -32.5,
    cy: 829.7,
    r: 101.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7d564c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58403a"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".b{fill:#bc8c75}.z{opacity:.5;mix-blend-mode:screen;fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M1889.9 762.7s6.2.9 18.6 3.1c12.4 2.2 11.3-3.9 22.1-.6 4.7 1.4 15.1 2.9 25.3 4.2-.2 3.9-.4 7.7-.5 11-.1 13-2 27-15.2 32.2-19 7.4-51.3-9.5-49.6-22.9 1.7-13.4-.7-27-.7-27z",
    style: {
      fill: "url(#g1)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1130.8 1017.2c9-7.4 31.8-22.2 39.2-32.7 7.5-10.5 28.3-41.8 36.6-53.1 8.2-11.3 8.5-27.1 8.5-27.1-1.6-5.5-4.5-60.8-7-67.8-2.5-7.1-9.8-21.9-8.4-25.9 3.5-9.7 23.6-27.1 23.6-27.1l870.4 5.6 8.1 331.4s-35.3.3-37.4.9c-2 .7-49.5 10.5-49.5 10.5s-67.6-3.8-69.1-3.8c-1.5.1-97.1 4.7-97.1 4.7l-26.9-7.3s-9.3-.8-16.5-2.5c-7.3-1.6-44.9-6.7-44.9-6.7s-82.1 8.7-84 5.1c-1.8-3.6-63.7-5.8-71.9-6.1-8.2-.3-11.5-6.2-11.5-6.2s-13.8 2.7-18.7 2.8c-4.9.1-17.3-4.8-26-3.6-8.7 1.3-14.9.4-14.9.4l-11.6 9.9c-11-7.5-39.3-8.6-39.3-8.6s-16.6-4.3-24.2-2.5c-7.7 1.8-19.6-2.6-22.7-2.5-3.1.1-18.8-8-18.8-8s-23 2.2-23.8 2.7c-.8.6-46.9-4.4-46.9-4.4l-27.7 6.3-18.4-10.5s-45.3-.5-51.8-2.7c-6.5-2.3-21.6-9.2-28.8-9.8-7.2-.6-31.8.9-31.8.9-10.5-7.4-61.3-23.5-69.1-26.1-7.8-2.6-18.8-13.3-18.8-13.3s22-15.6 31.1-22.9z",
    className: "b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1971.2 827.9c-11.8 63.3-23.1 127.3-32.3 191.6-2.4-32.4-1.4-65.3.6-98.3-12.3-25.8-23-51.7-31.9-78 14.4-10.9 29.1-21.4 43.9-31.6 6.5 5.6 13.2 10.9 19.7 16.3z",
    style: {
      opacity: 0.4,
      fill: "url(#g2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1939.8 1013.2q-.5 3.2-.9 6.3c-2.4-32.4-1.4-65.3.6-98.3-12.3-25.8-23-51.7-31.9-78 12.1-9.1 24.5-18 36.9-26.7-1.5 10.3-1.5 20.7-1 31.3 1 22.7 2.8 44.8 2.3 67.6-.6 25.7-2.8 51.4-5 77.1q-.9 10.4-1 20.7z",
    style: {
      opacity: 0.4,
      mixBlendMode: "multiply",
      fill: "url(#g3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1939.3 920.7c-12.2-25.6-22.8-51.4-31.7-77.5 14.4-10.9 29.1-21.4 43.9-31.6 6.5 5.6 13.2 10.9 19.7 16.3q-3.3 17.6-6.5 35.4c-5.7-7.3-13.1-13.9-22.2-10.7-7.4 2.7-17.2 14.9-15 23.6 4.1 15.4 8.9 29.6 11.8 44.5z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2093.7 789.1 8.1 331.4s-35.3.3-37.4.9c-2 .7-49.5 10.5-49.5 10.5s-67.6-3.8-69.1-3.8c-1.5.1-97.1 4.7-97.1 4.7l-24.8-6.7c1.6-16.2 2.9-32.4 2.7-48.6-.3-18.7-3.8-36.5-2.7-55.4 1.1-18.3 9.5-34.9 9.9-53.1.2-11.5-7.5-21.2-12.3-31.4-.6-5.4-1.1-10.7-1.6-15.9-1.7-17.9-4.5-35.3-7.3-53-2.9-19.1-5-38.3-6.8-57.5-.7-8.1-2.3-16.1-4-24l89.9.6c10.5 45.9 27.1 89.7 47.8 133.4-2 33-3 65.9-.6 98.3 11.1-77.7 25.3-155.1 39.7-231.2z",
    style: {
      opacity: 0.7,
      mixBlendMode: "multiply",
      fill: "url(#g5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.6 1015c-7.5 20.7-16.7 42-25.9 63.7-.1-.1-.2-.1-.3-.1-7.2-.6-31.8.9-31.8.9-10.5-7.4-61.3-23.5-69.1-26.1-7.8-2.6-18.8-13.3-18.8-13.3s22-15.6 31.1-22.9c9-7.4 31.8-22.2 39.2-32.7 7.5-10.5 28.3-41.8 36.6-53.1 8.2-11.3 8.5-27.1 8.5-27.1-1.6-5.5-4.5-60.8-7-67.8-2.5-7.1-9.8-21.9-8.4-25.9 3.5-9.7 23.6-27.1 23.6-27.1h2.8c8 43.3 26.3 85.3 42.2 126.5-6.9 35.8-9.3 73-22.7 105z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1342.7 1096.1-24.3 5.5-14-8c-3-32.4-6.1-64.8-9.9-95.7-10.5-68.9-54.5-139.8-68.4-214.4l110.1.7c.3 41 12.9 80.1 25.9 119.2-21.2 62-21.6 127.1-19.4 192.7z",
    style: {
      opacity: 0.1,
      mixBlendMode: "screen",
      fill: "url(#g7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.8 813.9c-26.9-3.8-68.5 7.6-88.7-15.9-1.1-4.8-2.1-9.7-3-14.5l110.1.7c.3 41 12.9 80.1 25.9 119.2-1 2.9-1.9 5.8-2.8 8.8-7.8-19.7-16.1-39.3-20.9-60.1-2.4-10.5-6.3-33.3-18.6-37-.4-.6-1-1.1-2-1.2z",
    style: {
      opacity: 0.3,
      mixBlendMode: "multiply",
      fill: "url(#g8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.2 1099.7h-.2c-.8.6-46.9-4.4-46.9-4.4l-3.4.8c-2.2-65.6-1.8-130.7 19.4-192.7 7.8 23.2 15.7 46.4 21.3 70.1-3.2-3.1-6 6.4-9.2 3.3 1 41.1 11.5 82 19 122.9z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.3 920.7c-26.8-42-47.8-86.4-61.6-136.2l34.7.2c3.1 46 21.7 91.4 26.9 136z",
    style: {
      opacity: 0.1,
      mixBlendMode: "screen",
      fill: "url(#g10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.3 920.7c1.3 10.8 1.8 21.7 1.1 32.4-.8 46.6-11.9 95.8-16.4 145-1.3-.7-2.2-1.1-2.2-1.1s-21.5 2-23.6 2.7c-7.5-40.9-18-81.8-19-122.9 3.2 3.1 6-6.4 9.2-3.3-15.1-63.4-46.7-124-47.2-189.3l36.5.3c13.8 49.8 34.8 94.2 61.6 136.2z",
    style: {
      opacity: 0.2,
      mixBlendMode: "multiply",
      fill: "url(#g11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.7 821.6c20.8 87.5 16.5 175.8-2 267.4-.8 5.7-1 11-.8 16.3-1-.2-1.8-.4-2.3-.3-2.4 0-12.1-4.7-16.6-6.9 4.5-49.2 15.6-98.4 16.4-145 .7-10.7.2-21.6-1.1-32.4-5.2-44.6-23.8-90-26.9-136l55.7.3c-5.1 14-12.6 26-22.4 36.6z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.3 819.6c-2.3-11.6-4.1-23.2-4.9-34.9l55.7.3c-5.1 14-12.6 26-22.4 36.6 11.3 47.7 15.1 95.7 13.3 144.3-.9-11.8-1.9-23.6-2.9-35.3-1.5-17.6-3.1-35.4-7.3-52.5-4.9-20.1-12.7-39.1-13.2-60.1-.1-1.5-1.6-3.3-3.3-3.1-5.3.8-10.1 3-15 4.7z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1530.4 1111.2-8.6 7.4c-11-7.5-39.3-8.6-39.3-8.6l-.8-.2c-3-52.2-9.8-103.9-27.3-154.1.9-45.1-3.2-89.7-13.7-134.1 9.8-10.6 17.3-22.6 22.4-36.6l27.8.2c13.3 56.2 29.8 112 33.9 165.6 3.5 52.2 3.9 106.1 5.6 160.4z",
    style: {
      opacity: 0.6,
      mixBlendMode: "multiply",
      fill: "url(#g14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.9 1026.9c-20.2-79.5-35.2-159.5-45.1-241.3l28.8.2c3.4 80.6 13.6 161.1 16.3 241.1z",
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply",
      fill: "url(#g15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559 845.3c-3-19.8-5.8-39.7-8.2-59.7l28.8.2c3.2 77 12.7 153.8 15.9 230.2-6.5-56.8-.3-124.5-36.5-170.7z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.2 1091.8c-14.4-54.3-46.9-102.4-72.7-154.3-5.5-49.5-20.4-100.8-32.6-152.3l59.9.4c9.9 81.8 24.9 161.8 45.1 241.3.7 21.7.9 43.3.3 64.9z",
    style: {
      opacity: 0.2,
      mixBlendMode: "multiply",
      fill: "url(#g17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.2 786.4c32.1 77.4 65.1 158 76.4 241.2.1 5 .1 10 .3 15-1.6 24.7-1.5 49.4.8 74-1.5-.2-2.3-.3-2.3-.3s-58.9 6.2-78.1 6c.4-54.3 3.7-108.7-6.1-162.7-6.8-57.9-16-115.6-25.4-173.4z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.8 857.3c-9.1 3.7-17.4 8.7-25.5 14.3-4.3-28.5-8.9-56.9-13.5-85.4l34.4.2c27.6 66.4 55.7 135.1 70.3 205.9-8.4-24-17.7-47.6-27.4-71.1-8.6-20.7-16.3-47.6-34.5-61.8-.4-1.7-1.8-2.9-3.8-2.1z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.5 955.8c-3.5 23.9-5 47.9-4.9 71.8-11.3-83.2-44.3-163.8-76.4-241.2l55.1.4c3.3 23.8 10.4 46.9 16.7 70.2 4 14.3 6.8 28.8 10.1 43.3 4.5 19.5 2.3 36-.6 55.5z",
    style: {
      opacity: 0.2,
      mixBlendMode: "multiply",
      fill: "url(#g20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.3 844.1c-5.5 5-12.7 8.3-16.7 14.8-.7.4-1.3 1-1.4 2.1-1 8-.4 16 1 24-12-33.4-25.6-66.3-39-98.6l55.1.4c3.3 23.8 10.4 46.9 16.7 70.2 4 14.3 6.8 28.8 10.1 43.3 4.1 17.7 2.7 33 .2 50.3-.5-8.8-1.1-17.5-2-26.3-2.7-26.2-6.5-56.7-18.3-80.5-1.1-2.3-3.7-1.8-4.9-.2-.3.2-.5.3-.8.5z",
    style: {
      opacity: 0.3,
      mixBlendMode: "multiply",
      fill: "url(#g21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.6 935c-7.6-50.1-15.6-101-32.8-149.1l46 .3c9.4 57.8 18.6 115.5 25.4 173.4 1.8 9.7 3.1 19.4 4.1 29.2-13.1-19.1-27.3-36.6-42.7-53.8z",
    style: {
      opacity: 0.2,
      mixBlendMode: "screen",
      fill: "url(#g22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.3 1122.3c-3.4-.1-5.6-.4-5.9-.9-1.8-3.6-63.7-5.8-71.9-6.1-4.4-.1-7.3-1.9-9.2-3.5 6-108-11.1-216.8-15.7-326l25.2.1c17.2 48.1 25.2 99 32.8 149.1 15.4 17.2 29.6 34.7 42.7 53.8 4.6 44.4 2.4 88.9 2 133.5z",
    style: {
      opacity: 0.7,
      mixBlendMode: "multiply",
      fill: "url(#g23)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2096.8 857s-2.4.6-16.8-1.2c-14.4-1.7-48.5-3.5-48.5-3.5s-12.8.9-23.6 2.2c-10.8 1.4-17-.6-25.6 2.8-8.7 3.4-15.9 5.2-18 2.6-2.1-2.6-10.6-14.5-14.9-20.7-4.2-6.2-7.8-3-15.3 2.5-7.6 5.5-18.7 16.3-20.2 16.8-1.5.6-29.4-2.4-39.1-1.1-9.8 1.4-32.4-.2-43.6 3.8-11.3 4-15.4 4.6-18 2.6-2.6-2.1-5-14.6-10.2-17.7-5.2-3-34.6-7-41.4-10-6.7-3-13-7-13-7l-35.8 30.4-19.7-9.5c-14.8 6.7-33.5 28.3-33.5 28.3-4.8.6-45.7-7.3-52.5-8.1-6.7-.9-21 1.6-25.6.6-4.7-.9-16-20.6-18.1-22.2-2.1-1.5-7.9-7.7-13-7.5-5.2.1-26.9-3.6-32.5-5-5.7-1.4-20.7-4.7-29-5.6-8.2-.8-16.6-4.8-26.3-4-9.8.7-24.3-3.1-24.3-3.1l17.4-24.2c-18.4 4.2-43.6 21.7-43.6 21.7s-10.4-4.5-22.3-3.9c-11.8.6-15.4-2-30.8.5s-10.5-7.6-19.8-9.5c-9.3-1.8-25.8-5.1-36.1-3.8-10.2 1.3-56.5 1-64.2 1.2-7.8.2-15 .9-18.1-2.7-3.2-3.6 4-19.3 4-19.3s56.1-4.4 72-4.8c16-.4 17.6 1.6 34.4-3.6 16.9-5.1 58.1-.9 67.4-1.2 9.2-.2 27.8 2.5 39.5-2 11.7-4.6 33.7-9.9 37.9-7.9 4.1 2 12 6.6 18.6 7.5 6.8.8 19.2 3.1 26.4 4.4 7.2 1.3 16.4-3.5 25.6-4.8 9.2-1.2 38.9-6.2 47.9-5.4 8.9.8 13.2 2.3 29.2 2.6 15.9.3 79.1-.7 79.1-.7s56.5-4.6 75.1-1.9c18.6 2.7 27.3 3.5 44.8 2.4 17.4-1.1 43.7-1.1 43.7-1.1 11.3 2.2 19-.5 19-.5s13.8 15 16.4 17.6c2.6 2.6 24 13.6 21.9 12.1-2.1-1.5-7.5-11.4-12.8-17.6-5.3-6.2-21-15.8-21-15.8s6.2.9 18.6 3.1c12.4 2.2 11.3-3.9 22.1-.6 10.9 3.3 51.9 7 51.9 7s42.2-9.8 59.9-9.9c17.8 0 52-1.3 52-1.3z",
    className: "b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2096.8 857s-2.4.6-16.8-1.2c-14.4-1.7-48.5-3.5-48.5-3.5s-12.8.9-23.6 2.2c-10.8 1.4-17-.6-25.6 2.8-8.7 3.4-15.9 5.2-18 2.6-2.1-2.6-10.6-14.5-14.9-20.7-4.2-6.2-7.8-3-15.3 2.5-7.6 5.5-18.7 16.3-20.2 16.8-1.5.6-29.4-2.4-39.1-1.1-9.8 1.4-32.4-.2-43.6 3.8-11.3 4-15.4 4.6-18 2.6-2.6-2.1-5-14.6-10.2-17.7-5.2-3-34.6-7-41.4-10-6.7-3-13-7-13-7l-35.8 30.4-19.7-9.5c-14.8 6.7-33.5 28.3-33.5 28.3-4.8.6-45.7-7.3-52.5-8.1-6.7-.9-21 1.6-25.6.6-4.7-.9-16-20.6-18.1-22.2-2.1-1.5-7.9-7.7-13-7.5-5.2.1-26.9-3.6-32.5-5-5.7-1.4-20.7-4.7-29-5.6-8.2-.8-16.6-4.8-26.3-4-9.8.7-24.3-3.1-24.3-3.1l17.4-24.2c-18.4 4.2-43.6 21.7-43.6 21.7s-10.4-4.5-22.3-3.9c-11.8.6-15.4-2-30.8.5s-10.5-7.6-19.8-9.5c-9.3-1.8-25.8-5.1-36.1-3.8-10.2 1.3-56.5 1-64.2 1.2-7.8.2-15 .9-18.1-2.7-3.2-3.6 4-19.3 4-19.3s56.1-4.4 72-4.8c16-.4 17.6 1.6 34.4-3.6 16.9-5.1 58.1-.9 67.4-1.2 9.2-.2 27.8 2.5 39.5-2 11.7-4.6 33.7-9.9 37.9-7.9 4.1 2 12 6.6 18.6 7.5 6.8.8 19.2 3.1 26.4 4.4 7.2 1.3 16.4-3.5 25.6-4.8 9.2-1.2 38.9-6.2 47.9-5.4 8.9.8 13.2 2.3 29.2 2.6 15.9.3 79.1-.7 79.1-.7s56.5-4.6 75.1-1.9c18.6 2.7 27.3 3.5 44.8 2.4 17.4-1.1 43.7-1.1 43.7-1.1 11.3 2.2 19-.5 19-.5s13.8 15 16.4 17.6c2.6 2.6 24 13.6 21.9 12.1-2.1-1.5-7.5-11.4-12.8-17.6-5.3-6.2-21-15.8-21-15.8s6.2.9 18.6 3.1c12.4 2.2 11.3-3.9 22.1-.6 10.9 3.3 51.9 7 51.9 7s42.2-9.8 59.9-9.9c17.8 0 52-1.3 52-1.3z",
    style: {
      opacity: 0.5,
      mixBlendMode: "screen",
      fill: "url(#g24)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.9 812.9c-7.5 4.3-12.8 8-12.8 8s-10.4-4.5-22.3-3.9c-11.8.6-15.4-2-30.8.5s-10.5-7.6-19.8-9.5c-9.3-1.8-25.8-5.1-36.1-3.8-10.2 1.3-56.5 1-64.2 1.2-7.8.2-15 .9-18.1-2.7-3.2-3.6 4-19.3 4-19.3h1.4c-.4 5.1-.5 10.1.7 15.8.4 1.8 2.4 2.4 4 2.1 16.8-3.1 33.8-3 50.8-3.1 14.3-.1 28.6-2.7 42.8-2.4 11.9.4 20.5 10.2 31 14.7 8.9 3.7 18.4 4.9 27.9 5.5 13.9.9 27.7-.4 41.5-3.1zM2096.5 846.2l.3 10.8s-2.4.6-16.8-1.2c-14.4-1.7-48.5-3.5-48.5-3.5s-12.8.9-23.6 2.2c-10.8 1.4-17-.6-25.6 2.8-8.7 3.4-15.9 5.2-18 2.6-2.1-2.6-10.6-14.5-14.9-20.7-4.2-6.2-7.8-3-15.3 2.5-7.6 5.5-18.7 16.3-20.2 16.8-1.5.6-29.4-2.4-39.1-1.1-9.8 1.4-32.4-.2-43.6 3.8-11.3 4-15.4 4.6-18 2.6-2.6-2.1-5-14.6-10.2-17.7-5.2-3-34.6-7-41.4-10-6.7-3-13-7-13-7l-35.8 30.4-19.7-9.5c-14.8 6.7-33.5 28.3-33.5 28.3-4.8.6-45.7-7.3-52.5-8.1-6.7-.9-21 1.6-25.6.6-4.7-.9-16-20.6-18.1-22.2-2.1-1.5-7.9-7.7-13-7.5-5.2.1-26.9-3.6-32.5-5-5.7-1.4-20.7-4.7-29-5.6-8.2-.8-16.6-4.8-26.3-4-9.8.7-24.3-3.1-24.3-3.1l12.3-17q.6-.2 1.3-.4-1.7 3.5-3.2 7.1c-1 2.4.4 4.5 2.9 4.8 23.7 2.2 47.4 2.9 71 6.9 12.4 2.1 24.7 5.5 36 11.4 10.4 5.5 18.4 15 29 20.7 15.3 8.4 42 12.5 58.8 8 17.3-4.5 31.2-17.2 45.7-28.4 8.2 7 17.6 13.5 27.7 7.7 10.8-6 20.1-14.2 29.3-22.6 18.7 7.7 38.7 16 58.1 19.2 7.8 1.2 6.1 5 10.6 7.8 3.6 2.3 7 2.7 11.2 3.2 9.3 1.2 19.1-.4 28.4-1.7 9.4-1.4 18.8-3 28.4-3.7 8.9-.6 17.8 2 26.6.7 10.7-1.5 21.8-9.9 31.9-18.5 8.6 6.3 17.1 14.5 26.4 17.8 10.5 3.7 20.6.5 31.1.1 1.8 1 3.8 1.5 5.9 1.3 1.8-.3 3.2-1.5 3.1-3.3v-1.1c0-.9-.4-1.6-.9-2.2 1.1-1.1 1.3-2.9-.2-4.3-7.1-6.2-9.7-15.4-12.7-24.3 15.6 13.3 30.8 26.9 51.4 31.5 16 3.5 32.1 2.3 48.1 2.1z",
    className: "z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1984.9 813.3c-1.4-5.5-3.2-10.9-6-15.9 4.8 4.4 7.7 10 12.2 15 4.7 5.1 12.2 8.8 17.5 12.9 6.1 4.8 11.4 10.5 17.2 15.7 6 5.5 13.3 9 20.8 12.2-8.5-.5-15.1-.9-15.1-.9s-2.8.2-6.8.6c-3.4-3.3-7-6.4-10.7-9.5-6.2-5-12.2-10.1-18.4-15.1-4.1-4.5-7.8-9.4-10.7-15z",
    style: {
      fill: "url(#g25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1 754.7c1.8 13.4-30.6 30.3-49.5 22.9-13.2-5.2-15.2-19.2-15.3-32.2 0-3.2-.3-7.1-.5-11 10.3-1.3 20.6-2.8 25.3-4.2 10.9-3.3 9.7 2.8 22.1.6 12.4-2.2 18.6-3.1 18.6-3.1s-2.4 13.6-.7 27z",
    style: {
      fill: "url(#g26)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M932.1 1005.1s-11.1 10.7-18.9 13.3c-7.8 2.6-58.6 18.7-69 26.1 0 0-24.7-1.4-31.9-.8-7.2.6-22.3 7.4-28.8 9.7-6.5 2.3-51.7 2.7-51.7 2.7l-18.5 10.6-27.7-6.4s-46 5-46.8 4.4c-.8-.5-23.9-2.7-23.9-2.7s-15.7 8.1-18.7 8c-3.1-.1-15.1 4.3-22.7 2.5-7.7-1.8-24.2 2.6-24.2 2.6s-28.4 1-39.4 8.5l-11.5-9.9s-6.2.9-14.9-.3c-8.8-1.3-21.2 3.6-26.1 3.5-4.9-.1-18.7-2.8-18.7-2.8s-3.2 5.9-11.5 6.3c-8.2.3-70 2.4-71.9 6-1.8 3.6-83.9-5.1-83.9-5.1s-37.7 5.1-44.9 6.8c-7.3 1.6-16.6 2.5-16.6 2.5l-26.9 7.3s-95.5-4.7-97.1-4.8c-1.5 0-69.1 3.8-69.1 3.8s-47.5-9.8-49.5-10.4c-2-.7-37.4-1-37.4-1l8.2-331.4 870.3-5.6s20.1 17.4 23.6 27.1c1.5 4-5.8 18.8-8.3 25.9-2.5 7-5.4 62.3-7.1 67.8 0 0 .4 15.8 8.6 27.1s29 42.6 36.5 53.1c7.4 10.5 30.2 25.3 39.3 32.7 9.1 7.3 31.1 22.9 31.1 22.9z",
    className: "b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.2 776.6c14.9 10.2 29.5 20.8 44 31.6-9 26.3-19.7 52.2-32 78 2.1 33 3 65.9.7 98.3-9.3-64.3-20.6-128.3-32.4-191.6 6.6-5.4 13.2-10.7 19.7-16.3z",
    style: {
      opacity: 0.4,
      fill: "url(#g27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9 957.5c-2.1-25.6-4.3-51.4-4.9-77.1-.5-22.7 1.3-44.9 2.2-67.6.5-10.5.5-21-1-31.2 12.5 8.6 24.8 17.5 37 26.6-9 26.3-19.7 52.2-32 78 2.1 33 3 65.9.7 98.3l-1-6.2q-.1-10.4-1-20.8z",
    style: {
      opacity: 0.4,
      mixBlendMode: "multiply",
      fill: "url(#g28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2 841.2c2.3-8.7-7.6-20.9-15-23.6-9-3.2-16.4 3.4-22.2 10.7q-3.2-17.7-6.5-35.4c6.6-5.4 13.2-10.7 19.7-16.3 14.9 10.2 29.5 20.8 44 31.6-8.9 26.2-19.6 51.9-31.8 77.5 2.9-14.9 7.8-29.1 11.8-44.5z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1 753.4c14.4 76 28.6 153.4 39.8 231.1 2.3-32.4 1.4-65.3-.7-98.3 20.8-43.6 37.3-87.5 47.8-133.4l89.9-.6c-1.7 7.9-3.2 15.9-4 24-1.8 19.2-3.8 38.4-6.8 57.5-2.8 17.7-5.5 35.1-7.3 53-.5 5.2-.9 10.6-1.6 15.9-4.7 10.2-12.5 20-12.3 31.4.4 18.3 8.8 34.9 9.9 53.1 1.1 18.9-2.4 36.7-2.6 55.4-.2 16.3 1 32.5 2.6 48.6l-24.8 6.8s-95.5-4.7-97.1-4.8c-1.5 0-69.1 3.8-69.1 3.8s-47.5-9.8-49.5-10.4c-2-.7-37.4-1-37.4-1l8.2-331.4z",
    style: {
      opacity: 0.7,
      mixBlendMode: "multiply",
      fill: "url(#g30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.4 875c16-41.2 34.2-83.2 42.3-126.5h2.7s20.1 17.4 23.6 27.1c1.5 4-5.8 18.8-8.3 25.9-2.5 7-5.4 62.3-7.1 67.8 0 0 .4 15.8 8.6 27.1s29 42.6 36.5 53.1c7.4 10.5 30.2 25.3 39.3 32.7 9.1 7.3 31.1 22.9 31.1 22.9s-11.1 10.7-18.9 13.3c-7.8 2.6-58.6 18.7-69 26.1 0 0-24.7-1.4-31.9-.8h-.3c-9.1-21.7-18.3-43-25.8-63.7-13.5-31.9-15.9-69.2-22.8-105z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.2 962.9c4.4-28.9 14.8-58.2 26.2-87.9 6.9 35.8 9.3 73.1 22.8 105 7.5 20.7 16.7 42 25.8 63.7-7.3.7-22 7.5-28.5 9.7-6.5 2.3-51.7 2.7-51.7 2.7l-4.5 2.5c3.1-32.4 6.1-64.8 9.9-95.7z",
    style: {
      opacity: 0.2,
      mixBlendMode: "multiply",
      fill: "url(#g32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.6 868.4c13.1-39.1 25.6-78.2 26-119.2l110.1-.7c-13.9 74.6-58 145.5-68.5 214.4-3.8 30.9-6.8 63.3-9.9 95.7l-14 8.1-24.3-5.6c2.3-65.6 1.9-130.7-19.4-192.7z",
    style: {
      opacity: 0.1,
      mixBlendMode: "screen",
      fill: "url(#g33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712 780.1c-12.4 3.7-16.3 26.5-18.7 37-4.8 20.9-13.1 40.4-20.8 60.1q-1.4-4.4-2.9-8.8c13.1-39.1 25.6-78.2 26-119.2l110.1-.7c-.9 4.9-2 9.7-3.1 14.5-20.1 23.5-61.7 12.2-88.7 15.9-.9.2-1.6.6-1.9 1.2z",
    style: {
      opacity: 0.3,
      mixBlendMode: "multiply",
      fill: "url(#g34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.5 941.9c-3.2 3.1-6-6.5-9.2-3.4 5.6-23.6 13.6-46.9 21.3-70.1 21.3 62 21.7 127.1 19.4 192.7l-3.4-.8s-46 5-46.8 4.4h-.2c7.5-40.9 17.9-81.8 18.9-122.8z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m624.3 749.7 34.7-.2c-13.8 49.8-34.8 94.2-61.6 136.2 5.2-44.6 23.8-90 26.9-136z",
    style: {
      opacity: 0.1,
      mixBlendMode: "screen",
      fill: "url(#g36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m659 749.5 36.6-.3c-.6 65.3-32.2 125.9-47.3 189.3 3.2-3.1 6 6.5 9.2 3.4-1 41-11.4 81.9-18.9 122.8-2.1-.7-23.7-2.7-23.7-2.7s-.8.5-2.2 1.1c-4.5-49.2-15.6-98.4-16.3-145-.8-10.7-.3-21.6 1-32.4 26.8-42 47.8-86.4 61.6-136.2z",
    style: {
      opacity: 0.2,
      mixBlendMode: "multiply",
      fill: "url(#g37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.6 750 55.7-.3c-3.1 46-21.7 91.4-26.9 136-1.3 10.8-1.8 21.7-1 32.4.7 46.6 11.8 95.8 16.3 145-4.4 2.2-14.2 7-16.5 6.9-.6 0-1.4.1-2.3.3.1-5.3-.1-10.6-.9-16.2-18.5-91.6-22.7-179.9-1.9-267.5-9.9-10.6-17.4-22.6-22.5-36.6z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.4 779.9c-1.7-.2-3.2 1.6-3.2 3.2-.6 20.9-8.3 39.9-13.3 60-4.1 17.1-5.7 35-7.3 52.5-1 11.8-2 23.5-2.9 35.3-1.8-48.6 2-96.5 13.4-144.3-9.9-10.6-17.4-22.6-22.5-36.6l55.7-.3c-.8 11.7-2.6 23.3-4.9 35-4.9-1.8-9.7-4-15-4.8z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 915.8c4-53.6 20.5-109.4 33.9-165.6l27.7-.2c5.1 14 12.6 26 22.5 36.6-10.6 44.4-14.7 89-13.7 134.2-17.6 50.1-24.4 101.9-27.3 154.1l-.8.2s-28.4 1-39.4 8.5l-8.6-7.3c1.8-54.4 2.1-108.3 5.7-160.5z",
    style: {
      opacity: 0.6,
      mixBlendMode: "multiply",
      fill: "url(#g40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.2 750.8 28.8-.2c-10 81.8-25 161.8-45.2 241.4 2.8-80.1 13-160.6 16.4-241.2z",
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply",
      fill: "url(#g41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.3 981c3.2-76.4 12.6-153.2 15.9-230.2l28.8-.2c-2.5 20-5.2 39.9-8.3 59.7-36.2 46.2-30 113.9-36.4 170.7z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.8 992C456 912.4 471 832.4 481 750.6l59.9-.4c-12.3 51.6-27.1 102.8-32.7 152.4-25.8 51.8-58.3 100-72.6 154.2-.7-21.6-.5-43.2.2-64.8z",
    style: {
      opacity: 0.2,
      mixBlendMode: "multiply",
      fill: "url(#g43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 751.2c-9.5 57.8-18.7 115.5-25.5 173.4-9.8 54-6.5 108.4-6.1 162.7-19.2.3-78-6-78-6s-.9.1-2.3.3c2.2-24.6 2.3-49.3.7-73.9.2-5 .3-10.1.3-15.1 11.3-83.2 44.3-163.8 76.4-241.1z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.1 824.4c-18.1 14.2-25.9 41.1-34.5 61.8-9.7 23.5-19 47.1-27.4 71.1 14.6-70.8 42.8-139.5 70.3-205.8l34.5-.3c-4.7 28.5-9.3 57-13.6 85.4-8-5.5-16.4-10.6-25.5-14.3-2-.8-3.4.4-3.8 2.1z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "url(#g45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.6 865.3c3.3-14.4 6.2-29 10.1-43.3 6.4-23.2 13.4-46.4 16.7-70.2l55.1-.3c-32.1 77.3-65.1 157.9-76.4 241.1.1-23.9-1.3-47.9-4.9-71.8-2.9-19.5-5-36-.6-55.5z",
    style: {
      opacity: 0.2,
      mixBlendMode: "multiply",
      fill: "url(#g46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.7 808.6c-1.3-1.6-3.9-2.1-5 .2-11.8 23.8-15.6 54.3-18.2 80.5-.9 8.8-1.6 17.5-2 26.3-2.5-17.3-3.9-32.5.1-50.3 3.3-14.4 6.2-29 10.1-43.3 6.4-23.2 13.4-46.4 16.7-70.2l55.1-.3c-13.4 32.3-26.9 65.1-39 98.5 1.4-8 2-16 1-23.9-.1-1.1-.7-1.8-1.4-2.2-4-6.5-11.2-9.8-16.7-14.8-.2-.2-.5-.3-.7-.5z",
    style: {
      opacity: 0.3,
      mixBlendMode: "multiply",
      fill: "url(#g47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.4 953.8c13.1-19.1 27.4-36.6 42.8-53.8 7.6-50 15.5-101 32.7-149l25.3-.2c-4.7 109.2-21.8 218-15.8 326-1.8 1.6-4.8 3.4-9.2 3.6-8.2.3-70 2.4-71.9 6-.2.6-2.4.8-5.9.9-.3-44.5-2.6-89.1 2-133.5z",
    style: {
      opacity: 0.7,
      mixBlendMode: "multiply",
      fill: "url(#g48)"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-62.7 726s34.3 1.3 52 1.3c17.8.1 59.9 9.9 59.9 9.9s41-3.7 51.9-7c10.9-3.3 9.7 2.8 22.1.6 12.4-2.2 18.6-3.1 18.6-3.1s-15.7 9.6-20.9 15.8c-5.3 6.2-10.7 16.1-12.8 17.6-2.1 1.5 19.2-9.5 21.9-12.1 2.6-2.5 16.3-17.6 16.3-17.6s7.7 2.7 19 .5c0 0 26.3 0 43.7 1.1 17.5 1.1 26.3.3 44.9-2.4 18.5-2.7 75 2 75 2s63.2.9 79.2.6c15.9-.3 20.2-1.8 29.2-2.6 8.9-.8 38.6 4.2 47.8 5.5 9.3 1.3 18.4 6 25.6 4.7 7.3-1.2 19.7-3.6 26.4-4.4 6.7-.9 14.5-5.5 18.7-7.5 4.1-2 26.1 3.4 37.8 7.9 11.8 4.5 30.3 1.8 39.6 2.1 9.3.2 50.5-4 67.3 1.2 16.9 5.1 18.5 3.1 34.4 3.5 15.9.4 72 4.9 72 4.9s7.2 15.6 4 19.2c-3.1 3.6-10.3 2.9-18 2.7-7.7-.2-54 .2-64.3-1.2-10.2-1.3-26.8 2-36.1 3.8-9.3 1.9-4.4 12.1-19.8 9.5-15.3-2.4-19 .2-30.8-.5-11.8-.5-22.2 3.9-22.2 3.9s-25.3-17.5-43.7-21.7l17.4 24.2s-14.5 3.9-24.3 3.1c-9.7-.8-18 3.2-26.3 4-8.2.9-23.2 4.2-28.9 5.6-5.7 1.5-27.4 5.1-32.5 5-5.2-.2-11 6-13.1 7.6-2.1 1.5-13.4 21.2-18 22.1-4.7 1-19-1.5-25.7-.6-6.7.8-47.7 8.8-52.5 8.1 0 0-18.7-21.6-33.4-28.3l-19.8 9.5-35.8-30.4s-6.2 4.1-13 7c-6.8 3-36.2 7-41.4 10.1-5.2 3-7.6 15.6-10.2 17.6-2.6 2-6.7 1.4-17.9-2.6s-33.9-2.4-43.6-3.7c-9.8-1.3-37.6 1.6-39.2 1-1.5-.5-12.5-11.3-20.1-16.8-7.6-5.5-11.1-8.7-15.4-2.5-4.3 6.2-12.8 18.1-14.9 20.7-2.1 2.6-9.3.8-17.9-2.6-8.7-3.3-14.9-1.4-25.7-2.7-10.7-1.4-23.6-2.2-23.6-2.2s-34.1 1.7-48.5 3.4c-14.3 1.8-16.8 1.2-16.8 1.2z",
    className: "b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-62.7 726s34.3 1.3 52 1.3c17.8.1 59.9 9.9 59.9 9.9s41-3.7 51.9-7c10.9-3.3 9.7 2.8 22.1.6 12.4-2.2 18.6-3.1 18.6-3.1s-15.7 9.6-20.9 15.8c-5.3 6.2-10.7 16.1-12.8 17.6-2.1 1.5 19.2-9.5 21.9-12.1 2.6-2.5 16.3-17.6 16.3-17.6s7.7 2.7 19 .5c0 0 26.3 0 43.7 1.1 17.5 1.1 26.3.3 44.9-2.4 18.5-2.7 75 2 75 2s63.2.9 79.2.6c15.9-.3 20.2-1.8 29.2-2.6 8.9-.8 38.6 4.2 47.8 5.5 9.3 1.3 18.4 6 25.6 4.7 7.3-1.2 19.7-3.6 26.4-4.4 6.7-.9 14.5-5.5 18.7-7.5 4.1-2 26.1 3.4 37.8 7.9 11.8 4.5 30.3 1.8 39.6 2.1 9.3.2 50.5-4 67.3 1.2 16.9 5.1 18.5 3.1 34.4 3.5 15.9.4 72 4.9 72 4.9s7.2 15.6 4 19.2c-3.1 3.6-10.3 2.9-18 2.7-7.7-.2-54 .2-64.3-1.2-10.2-1.3-26.8 2-36.1 3.8-9.3 1.9-4.4 12.1-19.8 9.5-15.3-2.4-19 .2-30.8-.5-11.8-.5-22.2 3.9-22.2 3.9s-25.3-17.5-43.7-21.7l17.4 24.2s-14.5 3.9-24.3 3.1c-9.7-.8-18 3.2-26.3 4-8.2.9-23.2 4.2-28.9 5.6-5.7 1.5-27.4 5.1-32.5 5-5.2-.2-11 6-13.1 7.6-2.1 1.5-13.4 21.2-18 22.1-4.7 1-19-1.5-25.7-.6-6.7.8-47.7 8.8-52.5 8.1 0 0-18.7-21.6-33.4-28.3l-19.8 9.5-35.8-30.4s-6.2 4.1-13 7c-6.8 3-36.2 7-41.4 10.1-5.2 3-7.6 15.6-10.2 17.6-2.6 2-6.7 1.4-17.9-2.6s-33.9-2.4-43.6-3.7c-9.8-1.3-37.6 1.6-39.2 1-1.5-.5-12.5-11.3-20.1-16.8-7.6-5.5-11.1-8.7-15.4-2.5-4.3 6.2-12.8 18.1-14.9 20.7-2.1 2.6-9.3.8-17.9-2.6-8.7-3.3-14.9-1.4-25.7-2.7-10.7-1.4-23.6-2.2-23.6-2.2s-34.1 1.7-48.5 3.4c-14.3 1.8-16.8 1.2-16.8 1.2z",
    style: {
      opacity: 0.5,
      mixBlendMode: "screen",
      fill: "url(#g49)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M648.4 781c9.4-.6 19-1.8 27.8-5.5 10.5-4.5 19.1-14.3 31-14.6 14.3-.4 28.5 2.2 42.8 2.3 17.1.1 34 0 50.9 3.1 1.6.3 3.5-.3 3.9-2.1 1.2-5.7 1.2-10.7.8-15.8.8 0 1.3.1 1.3.1s7.2 15.6 4 19.2c-3.1 3.6-10.3 2.9-18 2.7-7.7-.2-54 .2-64.3-1.2-10.2-1.3-26.8 2-36.1 3.8-9.3 1.9-4.4 12.1-19.8 9.5-15.3-2.4-19 .2-30.8-.5-11.8-.5-22.2 3.9-22.2 3.9s-5.3-3.6-12.9-8c13.8 2.7 27.7 4 41.6 3.1zM-16.7 809.1c20.6-4.6 35.8-18.2 51.4-31.5-3 8.9-5.6 18.1-12.7 24.3-1.5 1.4-1.2 3.2-.2 4.4-.5.5-.8 1.2-.9 2.1v1.1c0 1.9 1.4 3.1 3.1 3.3 2.1.2 4.1-.2 5.9-1.2 10.5.3 20.6 3.5 31.1-.2 9.4-3.3 17.9-11.5 26.4-17.7 10.1 8.6 21.2 16.9 32 18.4 8.8 1.3 17.6-1.3 26.6-.6 9.5.6 18.9 2.2 28.4 3.6 9.2 1.3 19 2.9 28.4 1.7 4.1-.5 7.6-.9 11.1-3.1 4.5-2.9 2.9-6.7 10.7-7.9 19.4-3.1 39.4-11.5 58-19.2 9.2 8.5 18.6 16.6 29.3 22.7 10.1 5.7 19.5-.8 27.7-7.7 14.5 11.1 28.4 23.8 45.8 28.4 16.8 4.4 43.4.3 58.8-8.1 10.5-5.7 18.5-15.2 28.9-20.7 11.3-5.9 23.6-9.3 36.1-11.4 23.5-4 47.3-4.7 71-6.9 2.5-.3 3.8-2.4 2.8-4.8s-2.1-4.8-3.2-7.1l1.4.4 12.2 17s-14.5 3.9-24.3 3.1c-9.7-.8-18 3.2-26.3 4-8.2.9-23.2 4.2-28.9 5.6-5.7 1.5-27.4 5.1-32.5 5-5.2-.2-11 6-13.1 7.6-2.1 1.5-13.4 21.2-18 22.1-4.7 1-19-1.5-25.7-.6-6.7.8-47.7 8.8-52.5 8.1 0 0-18.7-21.6-33.4-28.3l-19.8 9.5-35.8-30.4s-6.2 4.1-13 7c-6.8 3-36.2 7-41.4 10.1-5.2 3-7.6 15.6-10.2 17.6-2.6 2-6.7 1.4-17.9-2.6s-33.9-2.4-43.6-3.7c-9.8-1.3-37.6 1.6-39.2 1-1.5-.5-12.5-11.3-20.1-16.8-7.6-5.5-11.1-8.7-15.4-2.5-4.3 6.2-12.8 18.1-14.9 20.7-2.1 2.6-9.3.8-17.9-2.6-8.7-3.3-14.9-1.4-25.7-2.7-10.7-1.4-23.6-2.2-23.6-2.2s-34.1 1.7-48.5 3.4c-14.3 1.8-16.8 1.2-16.8 1.2l.3-10.8c16 .3 32.1 1.5 48.1-2.1z",
    className: "z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.1 793.4c-6.1 4.9-12.1 10-18.3 15-3.8 3.1-7.4 6.2-10.8 9.5-4-.4-6.8-.5-6.8-.5s-6.5.3-15.1.8C-7.4 815.1-.1 811.6 6 806c5.7-5.2 11-10.9 17.1-15.7 5.3-4 12.9-7.8 17.5-12.9 4.5-5 7.4-10.5 12.3-15-2.8 5-4.7 10.4-6 15.9-2.9 5.7-6.7 10.5-10.8 15.1z",
    style: {
      fill: "url(#g50)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocks);
export default __webpack_public_path__ + "static/media/rocks.a3f886e10cf6aa847b1534b96f08440c.svg";
export { ForwardRef as ReactComponent };